<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="slide-in">
            <Breadcrumb name="Volume Reports" :breadcrumb="breadcrumb"/>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card gradient-card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-3 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <SelectOptions
                      label=""
                      selectAppend="account"
                      labelValue="currency.code"
                      v-model="selectedAccount"
                      :url="showSelectAccountOption"
                      :externalData="$store.getters.getAccountData"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <InfiniteSelect
                      api-url="v1/get-stores"
                      ref="storeSelect"
                      :request-params="requestParams"
                      :formatter="(obj) => obj?.name || ''"
                      :response-parser="(response) => response?.response?.data?.data?.stores?.data || []"
                      :pagination-parser="parseStorePagination"
                      key-field="id"
                      @selectedFullObj="selectedFullObj"
                      placeholder-text="Search Store..."
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedTerminal">
                      <option :value="null">Select Terminal</option>
                      <option :key="index" :value="option" v-for="(option, index) in terminalData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="terminalLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedChannel">
                      <option :value="null">Select Channel</option>
                      <option :key="index" :value="option" v-for="(option, index) in channelData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="channelLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_plan">
              <span>Year Range</span>
              <RangeSlider v-model="yearRange" :min="yearMin" :max="yearMax" />
            </div>
            <div class="col-md-4 user_plan" v-if="showMonthFilter">
              <span>Month Range</span>
              <RangeSlider v-model="monthRange" :min="1" :max="12" :formatValue="formatMonthValue" />
            </div>
            <div class="col-md-4 user_plan" v-if="showDayFilter">
              <span>Day Range</span>
              <RangeSlider v-model="dayRange" :min="1" :max="31" />
            </div>
          </div>
          <div class="d-flex flex-wrap justify-content-center align-items-center gap-2 mt-3 mb-2">
            <!-- Generate – primary action -->
            <button type="button" class="btn btn-success" @click="onSubmitFilters">
              <i data-feather="play" class="me-25" size="16"></i> Generate
            </button>

            <!-- Download – secondary action (outline) -->
            <button type="button" class="btn btn-primary mx-1" @click="onDownload">
              <i data-feather="download" class="me-25" size="16"></i> Download
            </button>

            <!-- Clear – subtle action -->
            <button type="button" class="btn btn-secondary" @click="onClearFilters">
              <i data-feather="refresh-ccw" class="me-25" size="16"></i> Clear
            </button>
          </div>
<!--          <div class="d-flex justify-content-center align-items-center mx-50 row pt-0 pb-2 mt-5 mb-2">-->
<!--            <div class="col-md-12 user_status text-center">-->
<!--              <button type="button" class="btn btn-success" @click="onSubmitFilters">Generate</button>-->
<!--              <button type="button" class="ml-2 btn btn-secondary" @click="onClearFilters">Clear</button>-->
<!--            </div>-->
<!--          </div>-->
          <!-- Debug output for testing -->
<!--          <div class="mx-50 row pt-2 pb-2" style="background: #f5f5f5; padding: 10px; border-radius: 5px; font-size: 12px;">-->
<!--            <div class="col-md-12">-->
<!--              <strong>DEBUG - Slider Values:</strong><br>-->
<!--              Year Range: {{ Math.min(yearRange[0], yearRange[1]) }} - {{ Math.max(yearRange[0], yearRange[1]) }}<br>-->
<!--              Month Range: {{ Math.min(monthRange[0], monthRange[1]) }} ({{ getMonthName(Math.min(monthRange[0], monthRange[1])) }}) - {{ Math.max(monthRange[0], monthRange[1]) }} ({{ getMonthName(Math.max(monthRange[0], monthRange[1])) }})<br>-->
<!--              Day Range: {{ Math.min(dayRange[0], dayRange[1]) }} - {{ Math.max(dayRange[0], dayRange[1]) }}-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="card" v-if="showTable">
          <CommonTable
              url="v1/get-merchant-volume"
              :tableHeaderValues="tableHeaderValues"
              :filteredData="filteredData"
              :actions="[]"
              customClass="table-hover-animation"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from "vue";
import SearchSelect from "@/components/common/SearchSelect.vue";
import InfiniteSelect from "@/components/common/InfiniteSelect.vue";
import RangeSlider from "@/components/common/RangeSlider.vue";
import ToastificationContent from "@/components/common/ToastificationContent";
export default {
  components:{
    SearchSelect,
    InfiniteSelect,
    RangeSlider
  },
  mounted(){
    this.showSelectAccountOption = 'v1/get-wallet-list'
    const currentYear = new Date().getFullYear()
    this.yearMin = currentYear - 6
    this.yearMax = currentYear
    this.yearRange = [currentYear, currentYear]
  },
  data(){
    return{
      breadcrumb: [
        {name: 'App'},
        {name: 'Reports'},
        {name: 'Volume'},
      ],
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
      showSelectAccountOption: '',
      selectedAccount: null,
      filteredData:{},
      showTable: false,
      requestParams: {
        paginate:1
      },
      
      // Date range filters with sliders
      yearRange: [],
      yearMin: null,
      yearMax: null,
      monthRange: [1, 12],
      dayRange: [1, 31],
      
      tableHeaderValues: [
        {
          title: 'Year',
          valueKey: 'year',
        },
        {
          title: 'Month',
          valueKey: 'month',
          html: true,
          alter: (value) => {
            if(value === undefined || value === null || value === ''){
              return '-'
            }
            return this.getMonthName(value) || '-'
          }
        },
        {
          title: 'Day',
          valueKey: 'day',
        },
        {
          title: 'Amount',
          valueKey: 'totalAmount',
          html: true,
          alter: (value) => {
            var html=''
            if(value)
              html = `<div class="font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</div>`
            else
              html = '-'
            return html
          }
        },
        {
          title: 'Fee',
          valueKey: 'fee',
          html: true,
          alter: (value) => {
            var html=''
            if(value)
              html = `<div class="font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</div>`
            else
              html = '-'
            return html
          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          html: true,
          alter: (value) => {
            var html=''
            if(value)
              html = `<div class="font-weight-bolder text-dark">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</div>`
            else
              html = '-'
            return html
          }
        },
      ],
    }
  },
  methods:{
    selectedFullObj(item){
      if(item){
        this.selectedStore = item.id
        this.terminalData = item.terminals
      }else{
        this.selectedStore = null
        this.terminalData = []
      }
    },
    parseStorePagination(response) {
      let res = response?.response?.data?.data
      return {
        total: res?.stores?.paginationData?.total || 0,
        perPage: res?.stores?.paginationData?.perPage || 10
      };
    },
    getMonthName(monthNumber) {
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ]
      return months[monthNumber - 1] || monthNumber
    },
    formatMonthValue(value) {
      return this.getMonthName(value)
    },
    onSubmitFilters() {
      // Validate account selection
      if(!this.selectedAccount){
        this.toastG({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'BellIcon',
            text: 'Please select an account',
            variant: 'danger',
          },
        }, {toastClassName: 'badge-glow badge-danger'})
        return
      }

      let dataFiltered = {}

      if(this.selectedStore){
        dataFiltered.storeId = this.selectedStore
      }
      if(this.selectedTerminal){
        dataFiltered.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        dataFiltered.channelId = this.selectedChannel.id
      }

      if(this.selectedAccount){
        dataFiltered.userAccountId = this.selectedAccount.id
      }

      // Add merchantId from store
      if(this.$store.getters.getLoggedInUser){
        dataFiltered.merchantId = this.$store.getters.getLoggedInUser.id
      }

      if(this.yearRange && this.yearRange.length === 2){
        dataFiltered.fromYear = Math.min(this.yearRange[0], this.yearRange[1])
        dataFiltered.toYear = Math.max(this.yearRange[0], this.yearRange[1])
        
        // Only add month/day filters if years are the same
        if(dataFiltered.fromYear === dataFiltered.toYear){
          if(this.monthRange && this.monthRange.length === 2){
            dataFiltered.fromMonth = Math.min(this.monthRange[0], this.monthRange[1])
            dataFiltered.toMonth = Math.max(this.monthRange[0], this.monthRange[1])
            
            // Only add day filter if months are the same
            if(dataFiltered.fromMonth === dataFiltered.toMonth){
              if(this.dayRange && this.dayRange.length === 2){
                dataFiltered.fromDay = Math.min(this.dayRange[0], this.dayRange[1])
                dataFiltered.toDay = Math.max(this.dayRange[0], this.dayRange[1])
              }
            }
          }
        }
      }

      this.filteredData = dataFiltered
      this.showTable = true
    },
    onClearFilters() {
      this.selectedAccount = null
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      const currentYear = new Date().getFullYear()
      this.yearRange = [currentYear, currentYear]
      this.monthRange = [1, 12]
      this.dayRange = [1, 31]
      this.filteredData = {}
      this.showTable = false
      if(this.$refs.storeSelect){
        this.$refs.storeSelect.clearSearch()
      }
    },
    onDownload() {
      // Validate account selection
      if(!this.selectedAccount){
        this.toastG({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'BellIcon',
            text: 'Please select an account',
            variant: 'danger',
          },
        }, {toastClassName: 'badge-glow badge-danger'})
        return
      }

      this.onSubmitFilters()

      let requestData = {
        exportAs: 'excel',
        reportType: 'volume',
        download:1,
        ...this.filteredData
      }

      this.downloadReport(requestData, 'v1/get-merchant-volume')
    },
  },
  computed: {
    showMonthFilter() {
      // Show month filter only if start and end year are the same
      if(this.yearRange && this.yearRange.length === 2){
        return Math.min(this.yearRange[0], this.yearRange[1]) === Math.max(this.yearRange[0], this.yearRange[1])
      }
      return false
    },
    showDayFilter() {
      // Show day filter only if start and end month are the same (and years are same)
      if(this.showMonthFilter && this.monthRange && this.monthRange.length === 2){
        return Math.min(this.monthRange[0], this.monthRange[1]) === Math.max(this.monthRange[0], this.monthRange[1])
      }
      return false
    }
  },
  watch:{
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
      }
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      this.channelData = []
      if(val){
        this.channelData = val.channels
      }
    },
  }
}
</script>


<style>
.slide-in {
  animation: slideIn 0.6s ease-out;
}
@keyframes slideIn {
  from { opacity: 0; transform: translateX(-20px); }
  to { opacity: 1; transform: translateX(0); }
}
.animate-icon {
  animation: iconPop 0.5s ease;
}
@keyframes iconPop {
  0% { transform: scale(0); opacity: 0; }
  80% { transform: scale(1.2); }
  100% { transform: scale(1); opacity: 1; }
}
.gradient-card {
  background: linear-gradient(135deg, #f5faff 0%, #dde9f5 100%);
  border: none;
  box-shadow: 0 4px 20px rgba(42, 112, 154, 0.10);
  transition: box-shadow 0.3s ease, transform 0.2s ease;
}
.gradient-card:hover {
  box-shadow: 0 8px 30px rgba(42, 112, 154, 0.18);
  transform: translateY(-2px);
}
</style>
